export const CUT_STRATEGY_IDS = ["efficient_cutting", "preserve_offcuts", "strips"];

/** @type {Record<string, { id: string }>} */
export const CUT_STRATEGIES = Object.fromEntries(
  CUT_STRATEGY_IDS.map((id) => [id, { id }]),
);

export function getEffectiveSheetStrategy(exportDraft, sheetIndex) {
  const sheetStrategy = exportDraft.sheetStrategies?.[sheetIndex] || "inherit";
  return sheetStrategy === "inherit" ? exportDraft.globalStrategy : sheetStrategy;
}

export function getSheetStrategyOverride(exportDraft, sheetIndex) {
  const sheetStrategy = exportDraft.sheetStrategies?.[sheetIndex];
  if (!sheetStrategy || sheetStrategy === "inherit") return null;
  if (sheetStrategy === exportDraft.globalStrategy) return null;
  return sheetStrategy;
}

export function countSheetStrategyOverrides(exportDraft) {
  const { globalStrategy } = exportDraft;
  return Object.values(exportDraft.sheetStrategies || {})
    .filter((value) => value && value !== "inherit" && value !== globalStrategy).length;
}

export function getOffcutMode(strategy, exportDraft) {
  if (strategy === "strips") {
    return exportDraft.stripsNoCrosscut ? "split" : "merged";
  }

  return "merged";
}
